import { FC, useState } from "react";
import { ILocation, IObject } from "toolkit/steps/stepSeven/stepSeven.types";
import styles from "./Address.module.sass";
import cn from "classnames";
import { useAppSelector } from "toolkit/hooks";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { AssigningNumber } from "pages/StepPages/StepSeven/AssigningNumber/AssigningNumber";

interface AddressProps {
	address: ILocation;
	parent: IObject;
	objectNumber: number;
	sequenceNumber: number;
}

export const Address: FC<AddressProps> = ({ address, parent, objectNumber, sequenceNumber }) => {
	const { attachmentMode } = useAppSelector((state) => state.stepSeven);
	const [modalWindow, setModalWindow] = useState<boolean>(false);

	const clickHandler = () => {
		if (attachmentMode || !parent.fstekId) return;
		setModalWindow(true);
	};

	return (
		<>
			{modalWindow && (
				<ModalWindow close={() => setModalWindow(false)} scroll={false}>
					<AssigningNumber close={() => setModalWindow(false)} object={parent} address={address} />
				</ModalWindow>
			)}
			<tr onClick={clickHandler} className={styles.row}>
				<td className={cn(styles.item, attachmentMode && styles["item-padding"])}>
					<div className={styles["item-wrp"]}>
						{attachmentMode && (
							<label onClick={(e) => e.stopPropagation()} className={styles.label} htmlFor={`object-${parent.id}`}>
								<input
									id={`object-${parent.id}`}
									// checked={checkbox}
									// onChange={changeHandler}
									type="checkbox"
									className={styles.checkbox}
								/>
							</label>
						)}
						<div
							className={cn(styles.sign, address.fstekId ? styles["sign-assigned"] : styles["sign-unassigned"])}></div>
						{objectNumber + 1}.{sequenceNumber + 1}
					</div>
				</td>
				<td className={styles.item}>{address.code}</td>
				<td className={styles.item}>{address.name}</td>
				<td className={styles.item}>{address.type}</td>
				<td className={styles.item}>{address.activity}</td>
				<td className={styles.item}>{address.fstekId}</td>
			</tr>
		</>
	);
};
